/**
 * The current customer, as a module value: the API client stamps it on every
 * request (`X-Customer-Id`), the sticky run parameters are remembered per
 * customer. Set by the CustomerProvider; read here so the plumbing needs no
 * React context.
 */
import { LS_CUSTOMER_KEY } from "./config";

let currentCustomerId: string | null = null;

export function setCurrentCustomerId(id: string | null): void {
  currentCustomerId = id;
  try {
    if (id) window.localStorage.setItem(LS_CUSTOMER_KEY, id);
    else window.localStorage.removeItem(LS_CUSTOMER_KEY);
  } catch {
    /* private mode */
  }
}

export function getCurrentCustomerId(): string | null {
  return currentCustomerId;
}

/** The customer remembered by this browser, if any. */
export function loadRememberedCustomerId(): string | null {
  try {
    return window.localStorage.getItem(LS_CUSTOMER_KEY);
  } catch {
    return null;
  }
}
